export const UPLOAD_ADD = 'uploadQueue';
export const UPLOAD_DELETE = 'uploadDelete';

interface UploadAddAction {
  type: typeof UPLOAD_ADD;
  uuid: string;
  files: File[];
  fileNameUrlMap: Map<string, string>;
}

interface UploadDeleteAction {
  type: typeof UPLOAD_DELETE;
  uuid: string;
}

export type UploadHookActionTypes = UploadAddAction | UploadDeleteAction;
